import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionDetails, Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useState } from 'react';


export const MuiAccordionArray = (props: any) => {
  let {
    accordionArray = [],
    onClick,
    padding = 1,
  } = props;

  const [expanded, setExpanded] = useState<Record<string, boolean>>({});

  const handleChange =
    (panelId: string) =>
      (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded({ ...expanded, [panelId]: isExpanded });
        if (isExpanded && onClick) {
          onClick(panelId, isExpanded);
        }
      };

  return (
    <Box sx={{ padding: padding }}>
      {accordionArray?.map((item: any) => {
        return (
          <Accordion
            onChange={handleChange(item?.panelId)}
            key={item?.name}
            expanded={expanded[item?.panelId]}
          >
            <AccordionSummary
              key={item.panelId}
              expandIcon={
                <ExpandMoreIcon style={{ justifyContent: "flex-start" }} />
              }
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography sx={{ flexShrink: 2 }}>{item.name}</Typography>
            </AccordionSummary>
            {expanded[item?.panelId] && (
              <AccordionDetails key={item} sx={{ px: 0, pt: 0 }} >
                {item.child}
              </AccordionDetails>
            )}
          </Accordion>
        );
      })}
    </Box>
  );
};